export default {
    vestingSchedule: null,
    esoOverview: null,
    esopToken: {},
    esopOrder: [],
    employeeInvite: null,
    allEmployeeInvites: [],
    employeeInfo: null,
    pageInfo: {
        page: null,
        pages: null,
    },
};